import React from 'react';

import SimpleCollapse from '../../agent/components/SimpleCollapse';

import type { SerializedIconRegistry } from 'js/src/agent/registries/IconRegistry';
import LottieAsset from 'js/src/components/common/ui/LottieAsset';
import Tooltip from 'js/src/components/common/ui/Tooltip';

interface IconRegistryDisplayProps {
    iconRegistry: SerializedIconRegistry | null;
}

const IconRegistryDisplay: React.FC<IconRegistryDisplayProps> = ({ iconRegistry }) => {
    const items = iconRegistry?.items ?? [];
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="mt-l5-16">
            <SimpleCollapse
                title={
                    <div className="d-flex align-items-center">
                        <span className="me-l5-4" style={{ fontSize: '20px' }}>
                            ✨
                        </span>
                        <span className="fw-semibold">Icon Registry ({items.length} items)</span>
                    </div>
                }
                defaultExpanded={false}
            >
                <div className="p-l5-8 d-flex flex-wrap gap-3">
                    {items.map((item) => {
                        const lottieUrl = item.data?.icon?.url;
                        const { title } = item.representation;
                        return (
                            <Tooltip key={item.id} title={title}>
                                <div
                                    className="border rounded p-l5-8 d-flex flex-column align-items-center"
                                    style={{ width: '120px', flexShrink: 0 }}
                                >
                                    <div
                                        className="bg-grey-800 rounded mb-l5-4 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '100%',
                                            height: '100px',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {lottieUrl ? (
                                            <LottieAsset
                                                path={lottieUrl}
                                                className="w-100 h-100"
                                                playOnHover
                                                loop
                                                initialFrame="middle"
                                            />
                                        ) : (
                                            <i
                                                translate="no"
                                                className="material-symbols-outlined text-white"
                                                style={{ fontSize: '40px' }}
                                            >
                                                insert_emoticon
                                            </i>
                                        )}
                                    </div>
                                    <div className="text-center">{item.id}</div>
                                </div>
                            </Tooltip>
                        );
                    })}
                </div>
            </SimpleCollapse>
        </div>
    );
};

export default IconRegistryDisplay;
